import React from 'react';
import {
    Box,
    Typography,
    Card,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    TextField,
    MenuItem,
    Button,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import IOSSwitch from 'components/Fileds/IOSSwitch';
import "./style.css";
import MainContainer from 'theme/MainConatiner';
import CustomButton from 'components/Fileds/CustomButton';
import HeaderTilteBar from 'components/TitleBar/HeaderTilteBar';
import RestaurantTimingsSkeleton from './RestaurantTimingsSkeleton';
const generateTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
        for (let min of ['00', '30']) {
            const h = hour === 0 ? 12 : (hour > 12 ? hour - 12 : hour);
            const ampm = hour < 12 ? 'AM' : 'PM';
            const value = `${hour.toString().padStart(2, '0')}:${min}`;
            const label = `${h}:${min} ${ampm}`;
            options.push({ value, label });
        }
    }
    return options;
};
const TIME_OPTIONS = generateTimeOptions();
const RestaurantTimingsContainer = ({
    days,
    timings,
    onToggleDay,
    onAddSlot,
    onRemoveSlot,
    onUpdateSlot,
    onCopyAll,
    onSave,
    isSaving,
    overlaps,
    isLoading = false
}) => {
    return (
        <MainContainer>
            <Card className="restaurant-timings-page">
                <HeaderTilteBar
                    title={"Restaurant Timings"}
                    isSearch={false}
                    isAddVisible={true}
                    isIcon={false}
                    btnText={isSaving ? "Saving..." : "Save Timings"}
                    handleAddBtn={onSave}
                    addDisabled={isSaving || isLoading}
                />
                {isLoading ? (
                    <RestaurantTimingsSkeleton />
                ) : (
                    <Box className="timings-body">
                        {days.map((day, dayIdx) => {
                            const dayTiming = timings[dayIdx] || { is_open: false, slots: [] };
                            const dayOverlaps = overlaps?.[dayIdx] || [];
                        return (
                            <Accordion key={day} className="day-accordion"
                                sx={{
                                    "&.MuiAccordion-root:last-of-type": {
                                        borderBottomLeftRadius: "12px",
                                        borderBottomRightRadius: "12px",
                                    },
                                    "&.MuiAccordion-root:first-of-type": {
                                        borderTopLeftRadius: "12px",
                                        borderTopRightRadius: "12px",
                                    },
                                }}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Box className="day-summary">
                                        <Box className="day-name-section">
                                            <Box className={`status-dot ${dayTiming.is_open ? 'open' : 'closed'}`} />
                                            <Typography className="day-name">{day}</Typography>
                                            <Typography className="summary-slots">
                                                {dayTiming.is_open
                                                    ? (dayTiming.slots.length > 0
                                                        ? dayTiming.slots.map(s => {
                                                            const optOpen = TIME_OPTIONS.find(o => o.value === s.open_time);
                                                            const optClose = TIME_OPTIONS.find(o => o.value === s.close_time);
                                                            return `${optOpen?.label || s.open_time} - ${optClose?.label || s.close_time}`;
                                                        }).join(', ')
                                                        : 'No slots added')
                                                    : 'Closed'}
                                            </Typography>
                                        </Box>
                                        <Box className="toggle-section" onClick={(e) => e.stopPropagation()}>
                                            <Typography className="toggle-label">{dayTiming.is_open ? 'Open' : 'Closed'}</Typography>
                                            <IOSSwitch
                                                checked={dayTiming.is_open}
                                                onChange={() => onToggleDay(dayIdx)}
                                            />
                                        </Box>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box className="slot-container">
                                        {dayTiming.slots.map((slot, slotIdx) => (
                                            <React.Fragment key={slotIdx}>
                                                <Box className="slot-row">
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                        <AccessTimeIcon sx={{ color: '#666', width: '15px', height: '15px' }} />
                                                        <Typography className="slot-label">Slot {slotIdx + 1}</Typography>
                                                    </Box>
                                                    <Box className="slot-inputs">
                                                        <TextField
                                                            select
                                                            size="small"
                                                            value={slot.open_time}
                                                            onChange={(e) => onUpdateSlot(dayIdx, slotIdx, 'open_time', e.target.value)}
                                                            sx={{ width: 130 }}
                                                            error={dayOverlaps[slotIdx]}
                                                        >
                                                            {TIME_OPTIONS.map((opt) => (
                                                                <MenuItem key={opt.value} value={opt.value}>
                                                                    {opt.label}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                        <Typography className="to-label">to</Typography>
                                                        <TextField
                                                            select
                                                            size="small"
                                                            value={slot.close_time}
                                                            onChange={(e) => onUpdateSlot(dayIdx, slotIdx, 'close_time', e.target.value)}
                                                            sx={{ width: 130 }}
                                                            error={dayOverlaps[slotIdx]}
                                                        >
                                                            {TIME_OPTIONS.map((opt) => (
                                                                <MenuItem key={opt.value} value={opt.value}>
                                                                    {opt.label}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </Box>
                                                    <IconButton
                                                        onClick={() => onRemoveSlot(dayIdx, slotIdx)}
                                                        sx={{ color: '#F44336' }}
                                                    >
                                                        <DeleteOutlineIcon />
                                                    </IconButton>
                                                </Box>
                                            </React.Fragment>
                                        ))}
                                        {dayOverlaps.some(o => o === true) && (
                                            <Typography className="overlap-error">Overlaps with another time slot</Typography>
                                        )}
                                        <Box className="slot-actions">
                                            <Button
                                                startIcon={<AddIcon />}
                                                className="add-slot-btn"
                                                onClick={() => onAddSlot(dayIdx)}
                                            >
                                                Add Slot
                                            </Button>
                                            <Button
                                                startIcon={<ContentCopyIcon />}
                                                className="copy-all-btn"
                                                onClick={() => onCopyAll(dayIdx)}
                                            >
                                                Copy to All
                                            </Button>
                                        </Box>
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}
                </Box>
                )}
            </Card>
        </MainContainer>
    );
};
export default RestaurantTimingsContainer;
